import { Component, OnInit } from '@angular/core';
import { SharedService } from '../../services/core/shared.service';
import { ProductService } from '../../services/product.service';
import { ActivatedRoute } from '@angular/router';
//import * as $ from 'jquery';
//import * as _ from "lodash";
//import * as ex from 'ez-plus'

declare var jquery: any;
declare var $: any;

@Component({
  selector: 'app-details',
  templateUrl: './details.component.html',
  styleUrls: ['./details.component.css']
})
export class DetailsComponent implements OnInit {

  id: any
  p: any;
  imgs: any;
  ci: any;
  innerWidth;
  res;
  loading = false;
  // constant for swipe action: left or right
  SWIPE_ACTION = { LEFT: 'swipeleft', RIGHT: 'swiperight' };
  


  constructor(
    private activateRouter: ActivatedRoute,
    private sharedService: SharedService,
    private productService:ProductService) {

    this.activateRouter.paramMap.subscribe(params => {
      this.id = params.get('id');
      this.productService.readById(this.id).then(res => {
        this.p = res[0];
        ///console.log(this.p.dimensions.split(",")[0].replace(/[a-z: ]/g, ""));
        this.p.spoon = this.p.name.indexOf("cuchara") !== -1;
        this.p.cup = this.p.name.indexOf("Taza") !== -1;
        this.p.jar = this.p.name.indexOf("Tarro") !== -1;
        this.p.h = this.p.dimensions.split(",")[0].replace(/[a-z: ]/g, "");
        this.p.w =  this.p.dimensions.split(",")[1].replace(/[a-z: ]/g, "");
        this.p.size = this.p.h + "x" + this.p.w + " mm";
        this.p.related = JSON.parse(this.p.related);        

        //read images
        this.productService.readImagesByProductId(this.p.id).then(res => {
          this.imgs = res;
          this.imgs.forEach((x, i) => x.visible = false);
          this.imgs[0].visible = true;
          this.ci = this.imgs[0];

          setTimeout(function () {
            $(".imgzoom:eq(0)").click();
          }, 500);
        },err=>{console.error(err);}).catch(err=>{console.error(err);});
      },err=>{console.error(err);}).catch(err=>{console.error(err);});
    });
    
  }

  ngOnInit() {
    this.innerWidth = window.innerWidth;
    this.res = this.checkResolution(this.innerWidth);
    //console.log(this.res);
    /*
    this.sharedService.sharedData.subscribe(data => {
      if (data) {
        this.p = data;        
      }
    });*/


    /*this.activateRouter.paramMap.subscribe(params => {       
       this.id = params.get('id'); 
       console.log("pid: "+this.id);       
    });*/   
  }

  formatUrl(url){
    return url.replace('.jpg','_253.jpg');
  }

  displayMoney(amount) {
    return amount ? "$" + amount : "";
  }

  checkResolution(w) {

    if (w < 768) { return "xs"; }
    else if (w > 768 && w < 992) { return "sm"; }
    else if (w > 992 && w < 1200) { return "md"; }
    else if (w > 1200) { return "lg"; }
  }

  // action triggered when user swipes
  swipe(currentIndex: number, action = this.SWIPE_ACTION.RIGHT) {
    // out of range
    if (currentIndex > this.imgs.length || currentIndex < 0) return;

    let nextIndex = 0;

    // swipe right, next avatar
    if (action === this.SWIPE_ACTION.RIGHT) {
      const isLast = currentIndex === this.imgs.length - 1;
      nextIndex = isLast ? 0 : currentIndex + 1;
    }

    // swipe left, previous avatar
    if (action === this.SWIPE_ACTION.LEFT) {
      const isFirst = currentIndex === 0;
      nextIndex = isFirst ? this.imgs.length - 1 : currentIndex - 1;
    }

    // toggle avatar visibility
    this.imgs.forEach((x, i) => x.visible = (i === nextIndex));
  }
  onScroll() {
    /*this.loading = true;
    console.log("onScroll");
    setTimeout(function () {
      console.log("onScroll2");
      this.loading = false;
    }, 2000);*/
    
  }
  onChangeImg(img: any) {
    //console.log("onChangeImg");
    this.ci = img;
    setTimeout(function () {
      $("#zoom_01").ezPlus({ zoomWindowOffsetX: 10, borderSize: 1 });
    }, 500);
  }


}



// WEBPACK FOOTER //
// /Users/eduar.doramirez/developer/code/edd/ceramicamx/web/cmx-catalog/src/app/pages/details/details.component.ts